function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckbox = function SvgCheckbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 1c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-.6-.4-1-1-1h-.5c-.6 0-1 .4-1 1v3.5h-13v-13H10c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1H3Zm14.7 4.4c.5-.7.4-1.6-.3-2.1s-1.6-.4-2.1.3l-4.5 6.2-2.2-2c-.6-.6-1.6-.5-2.1 0-.6.6-.5 1.6 0 2.1l4.7 4.3 6.5-8.8Z",
    style: {
      fillRule: "evenodd"
    }
  }));
};
export default SvgCheckbox;